import React, { useEffect, useState } from "react";

// redux
import { useSelector } from 'react-redux';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// date picker
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

// icons
import { BsChevronDown } from "react-icons/bs";

// bootstrap
import Container from "react-bootstrap/esm/Container";

// styling
import { Spacing } from "_styles";

const DateTime = (props) => {

  // redux
  const usedTheme = useSelector(selectUsedTheme);
  const isBooking = props.isBooking

  // local state to control the date picker modal
  const [dateModal, setDateModal] = useState(false);


  // function to restrict going back more than 12 months
  const isValidDate = (currentDate) => {
    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12); // subtract 12 months from the current date

    return currentDate.isAfter(twelveMonthsAgo) || currentDate.isSame(twelveMonthsAgo, "day");
  };

  return (
    <>
      <style>
        {`
         .rdtPicker {
              background-color: ${isBooking ? 'white' : usedTheme.BACKGROUND_COLOR};
              color: ${isBooking ? 'black' : usedTheme.TEXT_COLOR};
              border: 1px solid ${isBooking ? '#ddd' : usedTheme.BORDER_COLOR};
              z-index: 9999;
          }

          .rdtDay {
            color: ${isBooking ? 'black' : usedTheme.TEXT_COLOR};
          }

          .rdtDay:hover {
            background-color: ${isBooking ? 'white' : usedTheme.BORDER_COLOR} !important;
            color: ${isBooking ? 'black' : usedTheme.TEXT_COLOR};
 !important;
            cursor: pointer;
            border-radius: 4px;
          }

          .rdtActive {
            background-color: #0d6efd !important;
            color: white !important;
          }

          .rdtSwitch, .rdtPrev, .rdtNext {
            color: ${isBooking ? 'black' : usedTheme.TEXT_COLOR};
          }
        `}
      </style>


      <div style={{ margin: 0, padding: 0 }} onClick={() => setDateModal(!dateModal)}>
        <div
          style={{
            //border: "1px solid #ccc",
            margin: 0, padding: 0,
            height: Spacing.SCALE_38,
            position: "relative",
          }}
          data-tippy-content="Filter By Date">

          <Datetime
            onClick={() => setDateModal(!dateModal)}
            open={dateModal}
            dateFormat="YYYY-MM-DD"
            value={props.date}
            timeFormat={false}
            onChange={(date) => {
              if (!(typeof date === "string")) {
                props.setDate(
                  new Date(
                    new Date(date).setHours(new Date(date).getHours() + 12)
                  )
                );
                setDateModal(!dateModal);
              }
            }}
            isValidDate={isValidDate}
            inputProps={{
              style: {
                fontSize: 16,
                backgroundColor: isBooking ? 'white' : usedTheme.BACKGROUND_COLOR,
                color: 'gray',
                alignItems: "center",
                display: "flex",
                textAlign: "center",
                borderColor: isBooking ? '#ddd' : usedTheme.BORDER_COLOR
              },
            }}
          />

          {/* icon to open the date picker */}
          <BsChevronDown
            size={16}
            style={{
              position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "gray",
            }}
          />

        </div>

      </div>
    </>
  );
};

export { default as CustomDropdown } from './custom-dropdown';

export default DateTime;
